export default "__VITE_ASSET__DOkfCNo7__"